import api from '@/api';
import state from '../state';

const store = {
  state: {
    outletlist: [],
    fetchingOutletlist: false,
    fetchingOrderdata: false
  },

  mutations: {
    SET_OUTLETLIST: (state, payload) => {
      state.outletlist = payload;
    },
    SET_IS_FETCHING_OUTLET_LIST: (state, payload) => {
      state.fetchingOutletlist = payload;
    },
    SET_IS_FETCHING_DOWNLOAD_DATA: (state, payload) => {
      state.fetchingOrderdata = payload;
    }
  },

  getters: {
    GetOutletCodeList: state => state.outletlist,
    GetOutletCodeFetching: state => state.fetchingOutletlist,
    GetDownloadOrdersFetching: state => state.fetchingOrderdata
  },

  actions: {
    async GetOutletCodeListRequest({ commit, state }, payload) {
      try {
        commit('SET_IS_FETCHING_OUTLET_LIST', true);
        const result = await api.GetOutletCodes(payload);
        commit('SET_IS_FETCHING_OUTLET_LIST', false);
        commit('SET_OUTLETLIST', result.data.data);
      } catch (e) {
        commit('SET_IS_FETCHING_OUTLET_LIST', false);
        throw e;
      }
    },

    async GetDownloadOrderstRequest({ commit, state }, payload) {
      try {
        commit('SET_IS_FETCHING_DOWNLOAD_DATA', true);
        const result = await api.GetDownloadOrders(payload);
        commit('SET_IS_FETCHING_DOWNLOAD_DATA', false);
        return result.data;
      } catch (e) {
        commit('SET_IS_FETCHING_DOWNLOAD_DATA', false);
        throw e;
      }
    },

    async DownLoadOrders({ commit }, payload) {
      try {
        const result = await api.DownLoadOrders(payload);
        return result;
      } catch (e) {
        return e;
      }
    }
  }
};

export default store;
